var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyIconOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2c0 .844.656 1.5 1.5 1.5A1.5 1.5 0 0 0 15.5 2c0-.813-.688-1.5-1.5-1.5A1.5 1.5 0 0 0 12.5 2zm-9 0C3.5 1.187 2.812.5 2 .5A1.5 1.5 0 0 0 .5 2c0 .844.656 1.5 1.5 1.5A1.5 1.5 0 0 0 3.5 2zm6 0C9.5 1.187 8.812.5 8 .5A1.5 1.5 0 0 0 6.5 2c0 .844.656 1.5 1.5 1.5A1.5 1.5 0 0 0 9.5 2z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIconOther);
export default __webpack_public_path__ + "static/media/survey-icon-other.a34c95bafdeb23f5d03b14aaeca61f68.svg";
export { ForwardRef as ReactComponent };